const getGraphQLErrorMessage = (err, fallback = "An unexpected error occurred!") => {
  if (!err) return fallback;

  const gqlErrors = err.graphQLErrors ?? [];
  const first = gqlErrors[0];

  // Lighthouse-style validation errors
  if (first?.extensions?.category === "validation" && first?.extensions?.validation) {
    const messages = Object.values(first.extensions.validation).flat().filter(Boolean);
    if (messages.length) return messages[0]; // or messages.join("\n")
  }

  // Your custom domain errors (e.g., thrown via GraphQLException)
  if (first?.extensions?.category === "custom" || first?.extensions?.code) {
    return first?.message ?? err.message ?? fallback;
  }

  // If we have GraphQL errors, surface them (deduped)
  if (gqlErrors.length) {
    const msgs = [...new Set(gqlErrors.map(e => e?.message).filter(Boolean))];

    if (msgs.length === 1 && msgs[0] === "Internal server error") return fallback;
    if (msgs.length) return msgs.join("\n");
  }

  // Apollo network/server errors
  const ne = err.networkError;

  if (ne) {
    const serverErrors = ne.result?.errors;
    if (Array.isArray(serverErrors) && serverErrors.length) {
      const msgs = serverErrors.map(e => e?.message).filter(Boolean);
      if (msgs.length) return msgs.join("\n");
    }
    // Optional: map common HTTP statuses to friendlier copy
    if (ne.statusCode === 401) return "Your session has expired. Please sign in again.";
    if (ne.statusCode === 403) return "You don’t have permission to perform this action.";
    if (ne.statusCode === 413) return "The request was too large.";
    return ne.message || fallback;
  }
  
  // Final fallback
  return err?.message || fallback;
};

export default getGraphQLErrorMessage;
